import { defineMessages } from 'react-intl';

export default defineMessages({
  socialAuthOr: {
    id: 'social.auth.or',
    defaultMessage: 'or',
  },
  socialAuthOrContinueWith: {
    id: 'social.auth.or-continue-with',
    defaultMessage: 'Or continue with:',
  },
  socialAuthContinue: {
    id: 'social.auth.continue',
    defaultMessage: 'Or continue with',
    description: `Precedes third party login buttons. For example, "Or continue with Google"`,
  },
  someOutageTitle: {
    id: 'some.outage.title',
    defaultMessage: 'Issues with some login options',
    description:
      'Message to the user that there are currently issues logging in with some providers due to an outage',
  },
  googleOutageTitle: {
    id: 'google.outage.title',
    defaultMessage: 'Issues with Google login',
    description:
      'Message to the user that there are currently issues logging in with Google due to an outage',
  },
  microsoftOutageTitle: {
    id: 'microsoft.outage.title',
    defaultMessage: 'Issues with Microsoft login',
    description:
      'Message to the user that there are currently issues logging in with Microsoft due to an outage',
  },
  appleOutageTitle: {
    id: 'apple.outage.title',
    defaultMessage: 'Issues with Apple login',
    description:
      'Message to the user that there are currently issues logging in with Apple due to an outage',
  },
  slackOutageTitle: {
    id: 'slack.outage.title',
    defaultMessage: 'Issues with Slack login',
    description:
      'Message to the user that there are currently issues logging in with Slack due to an outage',
  },
  someOutageDescription: {
    id: 'some.outage.description',
    defaultMessage:
      'Some login options are experiencing issues at the moment. You may be able to log in or sign up with your email and password instead.',
    description:
      'Message to the user that there are currently issues logging in with due to a login provider outage',
  },
  googleOutageDescription: {
    id: 'google.outage.description',
    defaultMessage:
      'There are issues with Google login and signup at the moment. If you are unable to continue with Google, you may be able to use your email and password instead.',
    description:
      'Message to the user that there are currently issues logging in with Google due to an outage',
  },
  microsoftOutageDescription: {
    id: 'microsoft.outage.description',
    defaultMessage:
      'There are issues with Microsoft login and signup at the moment. If you are unable to continue with Microsoft, you may be able to use your email and password instead.',
    description:
      'Message to the user that there are currently issues logging in with Microsoft due to an outage',
  },
  appleOutageDescription: {
    id: 'apple.outage.description',
    defaultMessage:
      'There are issues with Apple login and signup at the moment. If you are unable to continue with Apple, you may be able to use your email and password instead.',
    description:
      'Message to the user that there are currently issues logging in with Apple due to an outage',
  },
  slackOutageDescription: {
    id: 'slack.outage.description',
    defaultMessage:
      'There are issues with Slack login and signup at the moment. If you are unable to continue with Slack, you may be able to use your email and password instead.',
    description:
      'Message to the user that there are currently issues logging in with Slack due to an outage',
  },
});
